import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=1a68d95e&scoped=true&"
import script from "./OrderForm.vue?vue&type=script&lang=js&"
export * from "./OrderForm.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/order/OrderForm/OrderFormStyle.css?vue&type=style&index=0&id=1a68d95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a68d95e",
  null
  
)

export default component.exports